<!-- 个人中心 - 我的存证 -->

<template>
  <div id="framework-content">
    <!-- 当前位置 -->
    <div class="content-position">
      <span>我的存证</span>
      <ul>
        <li @click="openPage('/rights/file/dataList', true)">确权通道</li>
        <li @click="openPage('/lawService/wsLawyer/dataList', true)">法律服务
        </li>
        <li @click="openPage('/judicial/notarization/dataList', true)">司法通道</li>
      </ul>
    </div>
    <!-- 内容区域 -->
    <div class="content-main">
      <div class="content-search-area">
        <div class="search-box">
          <input placeholder="快速查找我的存证" v-model.trim="evidenceName" @keydown.enter="search">
          <!-- <img @click="search" src="../../assets/personal_center/search.png"> -->
          <button @click="search">查&nbsp;&nbsp;找</button>
        </div>
      </div>
      <div class="content-table">
        <div class="content-table-title">证据列表</div>
        <table class="table">
          <tr>
            <td style="width: 17%">关键词</td>
            <td style="width: 30%">证据链接</td>
            <td style="width: 17%">取证时间</td>
            <td style="width: 17%">查看证书</td>
            <td style="width: 19%">操作</td>
          </tr>
          <tr v-for="(result, index) in datas.data">
            <td>{{result.sourceTitle}}</td>
            <td :title="result.evidenceName" @click="openPage(result.sourceUrl, false)" class="url">{{result.sourceUrl}}</td>
            <td>{{result.evidenceFinishTime}}</td>
            <td :class="[{failed:result.saveStatus==3}]">
              <span v-if="result.saveStatus == 2" @click="openPage(result.detailUrl, true)" style="cursor:pointer" class="addHoverColor">
                {{result.statusDesc}}
              </span>
              <span v-else>
                  {{result.statusDesc}}
                  <span>{{result.extralDesc}}</span>
              </span>
            </td>
            <td class="data-actions">
              <span class="icon-box icon-download" title="下载" style="left: 30%" @click.stop="download(result.id)" v-if="result.saveStatus == 2"></span>
              <span class="icon-box icon-download-disabled" title="下载"  style="left: 30%" v-else></span>
              <span class="icon-box icon-delete" title="删除" style="left: 60%" @click.stop="removeRecord(result.id, index)"></span>
            </td>
          </tr>
        </table>
        <div class="no-data" v-if="!hasData">
          <img src="../../assets/images/personal/nodata.png">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;您目前还没有数据...</p>
        </div>
      </div>
      <paging-personal  :pageInfo="pageInfo" :isAsync="true" style="margin-top: 15px;"></paging-personal>
    </div>
  </div>
</template>

<style scoped>
  #framework-content .content-position {
    height: 71px;
    background-position: 0 27px; 
  }
  .content-position span{
    float: left;
    margin-top: 4px;
  }
  .content-position ul{
    float: right;
    font-size: 14px;
  }
  .content-position ul li {
    float: left;
    border: 1px solid #c45;
    color: #c45;
    padding: 6px 28px;
    cursor: pointer;
    border-radius: 5px;
  }
  .content-position ul li:hover{
    background: #c45;
    color: #fff;
  }
  .content-position ul li:nth-child(2){
    margin:0 20px;
  }
  .content-search-area {
    height: 94px;
    padding-top: 40px;
  }
  .content-search-area .search-box{
    height: 38px;
    width: 397px;
    margin: 0 auto;
  }
  .content-search-area .search-box input{
    height: 38px;
    width: 335px;
    border: 1px solid #dbdbdb;
    border-right: 0;
    float: left;
    padding-left: 10px;
  }
  .content-search-area .search-box button{
    width: 62px;
    height: 38px;
    border: 0;
    background: #c0404b;
    color: #fff;
    text-align: center;
    line-height: 38px;
    float: left;
    outline: 0;
    cursor:pointer;
  }
  .content-search-area .search-box button:hover{
   background: #ce5660;
  }
  .content-table .content-table-title{
    height: 34px;
    line-height: 34px;
    font-size: 16px;
  }
  .addHoverColor:hover{
    color: #c45!important;
  }
</style>

<script>
  import PagingPersonal from '@/components/common/PagingPersonal'
  import Loading from '@/components/common/Loading'
  import ActionModal from '@/components/common/ActionModal'
  import moment from 'moment'

  import SettingDisablePic from '../../assets/personal_center/setting_disable.png'
  import SettingPic from '../../assets/personal_center/setting.png'
  import RemovePic from '../../assets/personal_center/remove.png'

  export default {
    name: 'MyEvidences',
    components: {PagingPersonal, ActionModal, Loading},
    mounted(){
      this.userInfo = this.$getLocalStorage('IP360', 'user');
      let path = this.$router.currentRoute.path;
      this.$emit('childChange', path.substring(path.lastIndexOf('/')));
      this.dataRequest();
    },
    data() {
      return {
        datas:{
          data: [],
          page: {
          }
        },
        pageNum: 1,
        icon: {
          actions:[
            SettingDisablePic,
            SettingDisablePic,
            SettingPic,
            RemovePic
          ]
        },
        statusDesc:['排队中', '正在存证', '查看证书', '存证失败'],
        userInfo: {},
        hasData: true,
        isAsync: true,
        evidenceName: '',
        pageInfo:{
          pageNumber:1,
          pageSize:10
        }
      }
    },
    methods: {
      openPage(url, gotoIP360){
        if(url.indexOf('/') === 0){
          url = this.GlobalConfig.ip360Url + url;
        }
        if(gotoIP360){
          if(url.indexOf('?') < 0){
            url += '?u=' + this.userInfo.id + '&t=' + this.userInfo.token + '&from=truthso_search';
          }else{
            url += '&u=' + this.userInfo.id + '&t=' + this.userInfo.token + '&from=truthso_search';
          }
        }
        console.log('url:', url);
        window.open(url);
      },
      dataRequest(){
        this.$store.commit('showLoadingPersonal',true);
        let statusDesc = this.statusDesc;

        let query = this.$router.history.current.query
        let pageNo = query.pageNumber ? query.pageNumber : 1;
        let pageSize = query.pageSize ? query.pageSize : 10;
        let evidenceName = query.evidenceName ? query.evidenceName : '';

        let params = {
          operatorId: this.userInfo.id,
          pageNo,
          pageSize,
          searchType: 1,
          evidenceName,
          token: this.userInfo.token,
          timestamp:new Date().getTime()
        };

        this.$axios.request({
          url: '/webapi/personal/getTaskListByPage',
          method: 'get',
          params
        }).then((response) => {
          this.$store.commit('showLoadingPersonal',false);
          let result = response.data;
          if(result.code == 200){
            let pageInfo = {};
            pageInfo.pageNumber = result.datas.result.pageNumber;
            pageInfo.pageSize = result.datas.result.pageSize;
            pageInfo.totalPage = result.datas.result.totalPage;
            pageInfo.totalRow = result.datas.result.totalRow;
            this.pageInfo = pageInfo;

            if(result.datas.result.list.length > 0){
              this.hasData = true;
            }else {
              this.hasData = false;
            }
            result.datas.result.list.forEach((item) => {
              item.sourceTitle = item.sourceTitle || '';
              item.showAction = false;
              item.statusDesc = statusDesc[item.saveStatus];
              result.payStatus = 3;
              item.extralDesc = "";
              item.detailUrl = '';
              if(item.saveStatus == 2){
                if(item.evidenceType === 2){
                  item.detailUrl = "/evidenceTaken/snapshotRecord/dataList/Certificate?id=" + item.id + "&type=2&md5sign="+this.$md5(2+'truthso123'+item.id);
                }else{
                  item.detailUrl = "/evidenceTaken/screenRecord/dataList/Certificate?id=" + item.id + "&type=2&md5sign="+this.$md5(2+'truthso123'+item.id);
                }
              }
              if(result.payStatus == 3){
                result.extralDesc += "（退款成功）";
              }else if(result.payStatus == 4){
                result.extralDesc += "（退款失败）";
              }

            });
            this.datas.data = result.datas.result.list;
          }
        });
      },
      search(){
        let current = this.$router.history.current;
        this.$router.push({path: current.path, query: this.$getRouterQuery(current.query, {
          pageNumber: 1,
          evidenceName: this.evidenceName
        })});
      },
      //移除存证记录
      removeRecord(id, index){
        this.$axios.post('/webapi/personal/operateTask', {
          taskId: id,
          type: 2,
          token: this.userInfo.token
        }).then(response => {
          let result = response.data;
          if(result.code == 200){
            this.dataRequest();
          }else if(data.code == 102 || data.code == 103){
              this.$store.commit('logout');
              this.$router.push('/');
          }else{

          }
        });
      },
      download(id){
        let url = this.GlobalConfig.webApiServer + '/webapi/personal/packageDownloadSnap?snapShotId=' + id + '&token=' + this.userInfo.token;
        window.open(url);
      }
    },
    watch:{
      '$route' (to, from) {
        this.dataRequest();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MyEvidences.vue?34060a8a